<p-toast position="top-right"></p-toast>
<!-- Skeleton Loading State -->
<div *ngIf="isLoading" class="relative py-5 md:py-6 lg:py-8 xl:py-10 2xl:py-12 min-h-[75vh]">
    <div class="wrapper animate-pulse">
        <div class="flex flex-wrap md:flex-nowrap justify-between">
            <!-- Left Column Skeleton -->
            <div class="flex flex-col w-full md:pr-5 space-y-6 lg:space-y-9">
                <!-- Profile Header Skeleton -->
                <div class="flex">
                    <div class="mr-6">
                        <div class="w-[150px] lg:w-[160px] xl:w-[174px] aspect-square bg-gray-200 rounded-lg"></div>
                    </div>
                    <div class="flex-1 space-y-4 py-1">
                        <div class="h-8 bg-gray-200 rounded w-1/3"></div>
                        <div class="space-y-2 mt-4">
                            <div class="h-4 bg-gray-200 rounded w-1/2"></div>
                            <div class="h-4 bg-gray-200 rounded w-2/5"></div>
                        </div>
                    </div>
                </div>
                <!-- About Section Skeleton -->
                <div class="space-y-3">
                    <div class="h-8 bg-gray-200 rounded w-1/4"></div>
                    <div class="space-y-2 mt-3">
                        <div class="h-4 bg-gray-200 rounded w-full"></div>
                        <div class="h-4 bg-gray-200 rounded w-full"></div>
                        <div class="h-4 bg-gray-200 rounded w-3/4"></div>
                    </div>
                </div>
                <!-- Languages Skeleton -->
                <div class="space-y-3">
                    <div class="h-8 bg-gray-200 rounded w-1/5"></div>
                    <div class="flex space-x-3 mt-3">
                        <div class="h-8 bg-gray-200 rounded w-24"></div>
                        <div class="h-8 bg-gray-200 rounded w-24"></div>
                    </div>
                </div>
                <!-- Subjects Skeleton -->
                <div class="space-y-3">
                    <div class="h-8 bg-gray-200 rounded w-1/3"></div>
                    <div class="flex space-x-4 mt-3">
                        <div class="w-[140px] h-[100px] bg-gray-200 rounded-xl"></div>
                        <div class="w-[140px] h-[100px] bg-gray-200 rounded-xl"></div>
                        <div class="w-[140px] h-[100px] bg-gray-200 rounded-xl"></div>
                    </div>
                </div>
            </div>

            <!-- Right Column Sidebar Skeleton -->
            <div class="w-full md:w-auto self-start mt-6 md:mt-0">
                <div class="w-[320px] sm:w-[380px] lg:w-[420px] xl:w-[460px] 2xl:w-[500px] bg-white border border-gray-100 rounded-lg p-5 space-y-6 mx-auto sm:mx-0">
                    <!-- Video Placeholder -->
                    <div class="w-full h-[260px] bg-gray-200 rounded-lg"></div>
                    <!-- Rating and Price -->
                    <div class="flex justify-around">
                        <div class="h-8 bg-gray-200 rounded w-20"></div>
                        <div class="h-8 bg-gray-200 rounded w-20"></div>
                    </div>
                    <!-- Buttons -->
                    <div class="space-y-3 pt-4">
                        <div class="w-full h-12 bg-gray-200 rounded-lg"></div>
                        <div class="w-full h-12 bg-gray-200 rounded-lg"></div>
                        <div class="w-full h-12 bg-gray-200 rounded-lg"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="relative py-5 md:py-6 lg:py-8 xl:py-10 2xl:py-12" *ngIf="!isLoading && tutor">
    <div class="wrapper">
        <div class="flex flex-wrap md:flex-nowrap justify-between">
            <div class="flex flex-col w-full md:pr-5 space-y-6 lg:space-y-9">
                <div class="">
                    <div class="flex">
                        <div class="mr-6">
                            <div class="w-[150px] lg:w-[160px] xl:w-[174px] aspect-square">
                                <img [src]="tutor.user.profile_photo.url" alt="Tutor photo" class="tutor-photo w-full h-full object-cover rounded-lg">
                            </div>
                        </div>
                        <div class="">
                            <span class="block text-22 xl:text-[26px] 2xl:text-3xl font-bold">{{tutor.user.fname}} {{tutor.user.lname}}</span>
                            <!-- <p class="text-sm font-semibold text-gray_2 mt-1">Let's learn English together!</p> -->
                            <ul class="space-y-0 xl:space-y-3 mt-4">
                                <!-- <li class="flex items-center space-x-2 text-gray_2">
                                    <span class="icon-teaches text-xl lg:text-22 2xl:text-[24px] font-medium"></span>
                                    <span class="text-sm">Teaches lessons</span>
                                </li> -->
                                <li class="flex items-center space-x-2 text-gray_2">
                                    <span class="icon-teaches text-xl lg:text-22 2xl:text-[24px] font-medium"></span>
                                    <span class="text-sm">Teaches <strong>{{ getSubjectNames() }}</strong> lessons</span>
                                </li>
                                <!-- <li class="flex items-center space-x-2 text-gray_2">
                                    <span class="icon-speaks text-xl lg:text-22 2xl:text-[24px] font-medium"></span>
                                    <span class="text-sm">Speaks English (Native)</span>
                                </li>
                                <li class="flex items-center space-x-2 text-gray_2">
                                    <span
                                        class="icon-leassons-tough text-xl lg:text-22 2xl:text-[24px] font-medium"></span>
                                    <span class="text-sm">3 lessons taught</span>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="">
                    <span class="block text-22 xl:text-[26px] 2xl:text-3xl font-extrabold">About the tutor</span>
                    <p class="max-w-3xl w-full text-sm leading-6 text-gray_2 tracking-wide mt-3">{{ tutor.profile.about_summary }}</p>
                    <!-- <a href="#" class="inline-block font-semibold underline cursor-pointer mt-2.5">Show more</a> -->
                </div>
                <div class="flex flex-col w-full">
                    <span class="block text-22 xl:text-[26px] 2xl:text-3xl font-extrabold">I speak</span>
                    <div class="flex flex-wrap gap-6 mt-3">
                        <p *ngFor="let lang of tutor.languages" class="text-sm leading-6 text-gray_2 tracking-wide mt-3">{{lang.name}} <strong class="inline-block bg-green-200 rounded capitalize px-2 ml-1">{{lang.TutorLanguage.level}}</strong></p>
                    </div>
                </div>
                <div class="">
                    <!-- SUBJECT SELECTION CARDS -->
                    <div class="mb-8">
                        <span class="block text-22 xl:text-[26px] 2xl:text-3xl font-extrabold mb-6">Explore the subjects I teach</span>
                        <div class="flex flex-wrap gap-4">
                            <div *ngFor="let sub of tutor.subjects" 
                                    (click)="selectSubject(sub)"
                                    class="subject-card group flex flex-col items-center justify-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-300 w-[140px] h-[100px] text-center"
                                    [ngClass]="selectedSubject?.id === sub.id ? 'active-card bg-primary/5 border-primary shadow-md' : 'bg-white border-gray-100 hover:border-primary/30 hover:shadow-sm'">
                                    <span class="icon-teaches text-2xl mb-2 transition-transform duration-300 group-hover:scale-110" 
                                        [ngClass]="selectedSubject?.id === sub.id ? 'text-primary' : 'text-gray-400'"></span>
                                    <span class="text-sm font-semibold truncate w-full px-2"
                                        [ngClass]="selectedSubject?.id === sub.id ? 'text-primary' : 'text-gray-600'">{{ sub.name }}</span>
                            </div>
                        </div>
                    </div>

                    <span class="block text-22 xl:text-[26px] 2xl:text-3xl font-extrabold">Schedule</span>
                    <div class="rounded-lg mt-4">
                        <div class="flex items-center py-4 space-x-4">
                            <button (click)="previousWeek()" [disabled]="isPreviousButtonDisabled" class="p-2 rounded shadow hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                                <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
                            </button>
                            <button (click)="nextWeek()" [disabled]="isNextButtonDisabled" class="p-2 rounded shadow hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                                <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
                            </button>
                            <div class="text-lg font-semibold">
                                <span *ngIf="schedule.length > 0">{{ schedule[0].date | date:'MMM d' }} - {{ schedule[schedule.length - 1].date | date:'MMM d, y' }}</span>
                            </div>
                        </div>

                        <div class="grid grid-cols-7 gap-2">
                            <div *ngFor="let day of filteredSchedule; let i = index" class="text-center">
                                <div class="py-2 bg-gray_8 text-gray_2 rounded " [ngClass]="{'bg-primary text-white': i === 0}">
                                    <div class="font-semibold text-base">{{ day.date | date:'EEE' }}</div>
                                    <div class="font-semibold text-base">{{ day.date | date:'d' }}</div>
                                </div>
                                <div class="py-2 space-y-2">
                                    <div *ngIf="day.timeSlots.length === 0" class="text-gray-400 text-sm px-2 py-2">
                                        No slots
                                    </div>
                                    <div *ngFor="let slot of day.timeSlots | slice:0:(isScheduleExpanded ? day.timeSlots.length : 10)" class="px-2">
                                        <button class="w-full text-sm text-gray_10 border-0 py-1.5 hover:text-black transition-all" 
                                                [ngClass]="{'underline': !isSlotDisabled(day, $any(slot)), 'bg-primary/10 font-bold rounded text-primary': selectedSlot === slot}" 
                                                [disabled]="isSlotDisabled(day, $any(slot))"
                                                (click)="selectSlot(day, slot)">
                                            {{ $any(slot).start_time | slice:0:5 }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center my-4" *ngIf="canExpandSchedule">
                            <button (click)="toggleScheduleView()" class="text-blue-500 font-semibold hover:underline">
                                {{ isScheduleExpanded ? 'Show less' : 'View full schedule' }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="tutor?.experiences?.length !== 0 || tutor?.educations?.length !== 0">
                    <span class="block text-22 xl:text-[26px] 2xl:text-3xl font-extrabold mb-4">Resume</span>
                    <p-tabView>
                        <p-tabPanel header="Education" *ngIf="tutor?.educations?.length">
                            <div class="space-y-5">
                                <div *ngFor="let edu of tutor?.educations" class="relative pl-8 border-l border-gray_4">
                                    <span class="absolute -left-2.5 top-1.5 w-5 h-5 rounded-full bg-primary"></span>
                                    <p class="font-bold text-lg text-dark">{{ edu.university_name }}</p>
                                    <p class="text-gray_4 font-semibold">{{ edu.degree_type }}, {{ edu.specialization }}</p>
                                    <p class="text-gray_4 text-sm font-semibold">{{ edu.start_year }} - {{ edu.end_year }}</p>
                                </div>
                            </div>
                        </p-tabPanel>
                        <p-tabPanel header="Experience" *ngIf="tutor?.experiences?.length">
                            <div class="space-y-5">
                                <div *ngFor="let exp of tutor?.experiences" class="relative pl-8 border-l border-gray_4">
                                    <span class="absolute -left-2.5 top-1.5 w-5 h-5 rounded-full bg-primary"></span>
                                    <p class="font-bold text-lg text-dark">{{ exp.type }}</p>
                                    <p class="text-gray_4 font-semibold">{{ exp.institution_name }}, {{ exp.location }}</p>
                                    <p class="text-gray_4 text-sm font-semibold">
                                        {{ exp.start_month }}/{{ exp.start_year }} - 
                                        <ng-container *ngIf="exp.currentlyWorking">Present</ng-container>
                                        <ng-container *ngIf="!exp.currentlyWorking">{{ exp.end_month }}/{{ exp.end_year }}</ng-container>
                                    </p>
                                    <p class="mt-2 text-gray_4">{{ exp.teaching_summary }}</p>
                                </div>
                            </div>
                        </p-tabPanel>
                    </p-tabView>
                </div>
                <!-- Reviews Section -->
                <div class="mt-12 lg:mt-16 xl:mt-20">
                    <div class="flex items-center justify-between mb-8">
                        <h3 class="text-22 xl:text-[26px] 2xl:text-3xl font-extrabold">Student Reviews</h3>
                    </div>

                    <!-- Premium Rating Summary Dashboard -->
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8 items-center bg-gray-50/50 border border-gray-100/60 rounded-2xl p-6 md:p-8" *ngIf="totalReviews > 0">
                        <div class="text-center sm:border-r border-gray-100 last:border-0 py-2">
                            <span class="block text-4xl font-extrabold text-gray-900">{{ tutor.averageRating || 0 }}</span>
                            <div class="flex justify-center space-x-1 my-2">
                                <svg *ngFor="let i of [1,2,3,4,5]" xmlns="http://www.w3.org/2000/svg"
                                     class="w-5 h-5" viewBox="0 0 24 24">
                                    <defs>
                                        <linearGradient [id]="'avg-star-' + i" x1="0%" y1="0%" x2="100%" y2="0%">
                                            <stop [attr.offset]="getStarFillPercent(i, tutor.averageRating) + '%'" stop-color="#FBBF24"/>
                                            <stop [attr.offset]="getStarFillPercent(i, tutor.averageRating) + '%'" stop-color="#E5E7EB"/>
                                        </linearGradient>
                                    </defs>
                                    <path [attr.fill]="'url(#avg-star-' + i + ')'"
                                          d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                            </div>
                            <span class="text-xs text-gray-400 font-bold uppercase tracking-wider">Average Rating</span>
                        </div>
                        <div class="text-center sm:border-r border-gray-100 last:border-0 py-2">
                            <span class="block text-4xl font-extrabold text-gray-900">{{ totalReviews }}</span>
                            <span class="text-xs text-gray-400 font-bold uppercase tracking-wider mt-4 block">Total Reviews</span>
                        </div>
                        <div class="text-center py-2">
                            <span class="block text-4xl font-extrabold text-primary">100%</span>
                            <span class="text-xs text-gray-400 font-bold uppercase tracking-wider mt-4 block">Satisfaction Rate</span>
                        </div>
                    </div>

                    <div *ngIf="reviewsLoading" class="flex justify-center py-12">
                        <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
                    </div>

                    <div *ngIf="!reviewsLoading && reviews.length === 0" class="py-12 bg-gray-50 rounded-3xl text-center">
                        <p class="text-gray-400 font-bold">No reviews yet for this tutor.</p>
                    </div>

                    <!-- Optimized Review List (Borderless & Divided) -->
                    <div *ngIf="!reviewsLoading && reviews.length > 0" class="divide-y divide-gray-100">
                        <div *ngFor="let review of reviews" class="py-8 first:pt-0 last:pb-0">
                            <div class="flex items-start justify-between mb-4">
                                <div class="flex items-center space-x-4">
                                    <div class="w-12 h-12 rounded-xl overflow-hidden bg-gradient-to-tr from-primary/10 to-primary/5 ring-4 ring-gray-50 flex items-center justify-center">
                                        <img *ngIf="review.reviewer?.profile_photo?.url" [src]="review.reviewer?.profile_photo?.url" class="w-full h-full object-cover">
                                        <div *ngIf="!review.reviewer?.profile_photo?.url" class="font-extrabold text-primary text-lg">
                                            {{ review.reviewer?.fname?.charAt(0) }}
                                        </div>
                                    </div>
                                    <div>
                                        <h5 class="font-black text-gray-900 text-base">{{ review.reviewer?.fname }} {{ review.reviewer?.lname?.charAt(0) }}.</h5>
                                        <p class="text-xs font-bold text-gray-400 mt-0.5">{{ review.created_at | date:'MMMM d, y' }}</p>
                                    </div>
                                </div>
                                <div class="flex items-center space-x-0.5">
                                    <svg *ngFor="let i of [1,2,3,4,5]" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" [class.text-amber-400]="review.rating >= i" [class.text-gray-200]="review.rating < i" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                                </div>
                            </div>
                            <p class="text-gray-600 leading-relaxed font-semibold italic text-base">"{{ review.message }}"</p>

                            <!-- Dynamic Conversation Tutor Reply -->
                            <div *ngIf="review.comment" class="mt-6 p-5 bg-gray-50/60 border-l-2 border-primary/20 rounded-r-xl rounded-bl-xl relative">
                                <div class="flex items-center space-x-3 mb-3">
                                    <div class="w-8 h-8 rounded-lg overflow-hidden bg-gray-200 ring-2 ring-white shadow-sm flex items-center justify-center">
                                        <img [src]="tutor.user.profile_photo.url" class="w-full h-full object-cover">
                                    </div>
                                    <div>
                                        <span class="text-[10px] font-black text-primary uppercase tracking-widest">Tutor Response</span>
                                        <span class="block text-[9px] text-gray-400 font-bold">{{ review.comment.created_at | date:'MMMM d, y' }}</span>
                                    </div>
                                </div>
                                <p class="text-sm font-semibold text-gray-600 pl-1">{{ review.comment.message }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Show All Button -->
                    <div class="flex justify-center mt-10" *ngIf="totalReviews > 5">
                        <button type="button" 
                                class="px-10 py-3.5 bg-white border border-primary/20 text-primary font-bold rounded-xl shadow-[0_4px_14px_rgba(0,113,220,0.03)] hover:bg-primary hover:text-white hover:border-primary hover:shadow-[0_8px_25px_rgba(0,113,220,0.15)] hover:-translate-y-0.5 active:translate-y-0 active:scale-98 transition-all duration-300">
                            Show All
                        </button>
                    </div>
                </div>
            </div>
            <div class="w-full md:w-auto md:sticky md:top-24 self-start">
                <div
                    class="flex flex-col sm:flex-row md:flex-col w-[320px] sm:w-full md:w-[380px] lg:w-[420px] xl:w-[460px] 2xl:w-[500px] bg-white shadow-[0px_0px_20px_0px_#0000001A] rounded-lg space-y-4 sm:space-y-0 md:space-y-5 lg:space-y-6 xl:space-y-7 2xl:space-y-8 p-5 sm:space-x-5 md:space-x-0 mx-auto sm:mx-0">
                    <div class="sm:w-1/2 md:w-full space-y-5 lg:space-y-6 xl:space-y-7 2xl:space-y-8">
                        <div class="">
                            <div class="w-full max-h-[260px] h-full overflow-hidden rounded-lg" *ngIf="tutor.profile.introduction_video?.url == ''">
                                <img src="./assets/images/tutor-baner.png" alt="" class="w-full h-full object-cover">
                            </div>
                            <video class="block w-full h-full" [src]="tutor.profile.introduction_video?.url" controls *ngIf="tutor.profile.introduction_video?.url"></video>
                        </div>
                        <div class="">
                            <div class="flex justify-around">
                                <div class="">
                                    <span
                                        class="block text-center text-xl xl:text-2xl 2xl:text-3xl font-bold text-amber-500">★ {{ tutor.averageRating || 0 }}</span>
                                    <span class="block text-center tdext-base lg:text-lg xl:text-xl">Rating</span>
                                </div>
                                <div class="">
                                    <span class="block text-center text-xl xl:text-2xl 2xl:text-3xl font-bold">${{tutor.hourly_rate}}</span>
                                    <span class="block text-center tdext-base lg:text-lg xl:text-xl">per hour</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sm:w-1/2 md:w-full space-y-5 lg:space-y-6 xl:space-y-7 2xl:space-y-8">
                        <div class="space-y-3">
                            <button type="button" (click)="bookTrialLesson()"
                                class="w-full flex items-center justify-center space-x-3 text-sm lg:text-base xl:text-lg font-medium bg-primary border border-primary text-white rounded-lg p-2.5 lg:p-3 2xl:p-5">
                                <span class="icon-teaches text-lg md:text-xl xl:text-22 2xl:text-2xl font-medium"></span>
                                <span>Book Lesson</span>
                            </button>
                            <button type="button"
                                class="w-full flex items-center justify-center space-x-3 text-sm lg:text-base xl:text-lg font-medium border border-light_white rounded-lg p-2.5 lg:p-3 2xl:p-5">
                                <span class="icon-message text-lg md:text-xl xl:text-22 2xl:text-2xl"></span>
                                <span class="">Send Message</span>
                            </button>
                            <button type="button"
                                class="w-full flex items-center justify-center space-x-3 text-sm lg:text-base xl:text-lg font-medium border border-light_white rounded-lg p-2.5 lg:p-3 2xl:p-5">
                                <span class="icon-like text-lg md:text-xl xl:text-22 2xl:text-2xl"></span>
                                <span class="">Save</span>
                            </button>
                        </div>
                        <ul class="space-y-2.5 list-disc pl-5">
                            <li *ngIf="tutor.recent_lessons > 0" class="text-sm lg:text-base text-gray_2">
                                {{ tutor.recent_lessons }} lesson{{ tutor.recent_lessons !== 1 ? 's' : '' }} completed in the last 48 hours
                            </li>
                            <li *ngIf="tutor.recent_contacts > 0" class="text-sm lg:text-base text-gray_2">
                                Super popular: {{ tutor.recent_contacts }} session{{ tutor.recent_contacts !== 1 ? 's' : '' }} booked in the last 48 hours
                            </li>
                            <!-- <li class="text-sm lg:text-base text-gray_2">Usually responds in less than an hour</li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-8 sm:mt-10 md:mt-12 lg:mt-16 2xl:mt-20 hidden">
            <span class="block text-22 xl:text-[26px] 2xl:text-3xl font-extrabold">Certifications</span>
            <div class="flex flex-wrap items-center mt-6 -mx-1.5">
                <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-1.5">
                    <div class="w-full bg-gray_7 border border-gray_3 rounded-lg p-3 md:p-3.5 lg:p-4 xl:p-5">
                        <div
                            class="flex flex-wrap 2xl:flex-nowrap space-y-2 md:space-y-2.5 2xl:space-y-0 2xl:space-x-8">
                            <div class="">
                                <span class="text-lg font-semibold">2019 - 2023</span>
                            </div>
                            <ul class="w-full 2xl:w-auto space-y-1.5">
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">B.Tech</li>
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">University
                                    Name</li>
                                <li
                                    class="flex items-center text-sm md:text-base xl:text-lg font-semibold text-green-700 space-x-1.5">
                                    <span class="icon-verify"></span>
                                    <span class="text-sm ">Certificate verified</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-1.5">
                    <div class="w-full bg-gray_7 border border-gray_3 rounded-lg p-3 md:p-3.5 lg:p-4 xl:p-5">
                        <div
                            class="flex flex-wrap 2xl:flex-nowrap space-y-2 md:space-y-2.5 2xl:space-y-0 2xl:space-x-8">
                            <div class="">
                                <span class="text-lg font-semibold">2019 - 2023</span>
                            </div>
                            <ul class="w-full 2xl:w-auto space-y-1.5">
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">B.Tech</li>
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">University
                                    Name</li>
                                <li
                                    class="flex items-center text-sm md:text-base xl:text-lg font-semibold text-green-700 space-x-1.5">
                                    <span class="icon-verify"></span>
                                    <span class="text-sm ">Certificate verified</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-1.5">
                    <div class="w-full bg-gray_7 border border-gray_3 rounded-lg p-3 md:p-3.5 lg:p-4 xl:p-5">
                        <div
                            class="flex flex-wrap 2xl:flex-nowrap space-y-2 md:space-y-2.5 2xl:space-y-0 2xl:space-x-8">
                            <div class="">
                                <span class="text-lg font-semibold">2019 - 2023</span>
                            </div>
                            <ul class="w-full 2xl:w-auto space-y-1.5">
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">B.Tech</li>
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">University
                                    Name</li>
                                <li
                                    class="flex items-center text-sm md:text-base xl:text-lg font-semibold text-green-700 space-x-1.5">
                                    <span class="icon-verify"></span>
                                    <span class="text-sm ">Certificate verified</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-1.5">
                    <div class="w-full bg-gray_7 border border-gray_3 rounded-lg p-3 md:p-3.5 lg:p-4 xl:p-5">
                        <div
                            class="flex flex-wrap 2xl:flex-nowrap space-y-2 md:space-y-2.5 2xl:space-y-0 2xl:space-x-8">
                            <div class="">
                                <span class="text-lg font-semibold">2019 - 2023</span>
                            </div>
                            <ul class="w-full 2xl:w-auto space-y-1.5">
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">B.Tech</li>
                                <li class="flex items-center text-sm md:text-base xl:text-lg font-semibold">University
                                    Name</li>
                                <li
                                    class="flex items-center text-sm md:text-base xl:text-lg font-semibold text-green-700 space-x-1.5">
                                    <span class="icon-verify"></span>
                                    <span class="text-sm ">Certificate verified</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>